import { Moment } from "moment";
import PosicaoAtivo from "./posicaoAtivo";

export default class Pagamento implements IPagamento {
  public id!: string;
  public codigoAtivo!: string;
  public dataCredito!: Moment;
  public dataEx!: Moment;
  public tipo!: TipoPagamento;
  public valor!: number;
  public pagamento!: number;
  public acao!: "PAGAMENTO";
  public dataEvento!: Moment;
  public posicaoEx!: PosicaoAtivo;
  constructor(param: IPagamento) {
    Object.assign(this, param);
  }
}

interface IPagamento {
  id: string;
  codigoAtivo: string;
  dataCredito: Moment;
  dataEx: Moment;
  tipo: TipoPagamento;
  valor: number;
  pagamento: number;
  acao: "PAGAMENTO";
  dataEvento: Moment;
  posicaoEx: PosicaoAtivo;
}

export enum TipoPagamento {
  Dividendo = "DIVIDENDO",
  Juros = "JUROS SOBRE CAPITAL PRÓPRIO",
  Rendimento = "RENDIMENTO",
}
